(function () {
	const initProductAccordion = () => {
		document.querySelectorAll('details.about__accordion-item').forEach((details) => {
			const summary = details.querySelector('summary');
			const content = details.querySelector('.about__accordion-description');
			if (!summary || !content) return;

			summary.addEventListener('click', function(e) {
				e.preventDefault();
				if (details.open) {
					$(content).stop().slideUp(300, function() {
						details.removeAttribute('open');
					});
				} else {
					details.setAttribute('open', '');
					$(content).hide().stop().slideDown(300);
				}
			});
		});
	};

	document.addEventListener('shopify:section:load', function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
